/* Keep — theme.js. No dependencies. */
(function () {
  'use strict';
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    const [whole, dec] = amount.split('.');
    const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const withDots = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, `${withCommas}.${dec}`)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${withDots},${dec}`)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDots)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/, `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')},${dec}`);
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(text) {
    const el = $('#Toast');
    if (!el) return;
    $('.toast__text', el).textContent = text;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      el.classList.remove('is-visible');
      setTimeout(() => { el.hidden = true; }, 300);
    }, 4000);
  }

  /* ---------- Cart ---------- */
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (e) { /* silent */ }
  }

  async function addToCart(form, button) {
    const fd = new FormData(form);
    const original = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = '<span>Adding…</span>'; }
    try {
      const res = await fetch(window.theme.cartAddUrl + '.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      toast(`${data.product_title} added to cart`);
      refreshCartCount();
    } catch (err) {
      toast(err.message);
    } finally {
      if (button) { button.disabled = false; button.innerHTML = original; }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-ajax-add], [data-product-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, $('[type="submit"]', form));
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const wrap = (minus || plus).closest('.qty');
    const input = $('input', wrap);
    const min = parseInt(input.min || '0', 10);
    let v = parseInt(input.value || '1', 10);
    v = minus ? Math.max(min, v - 1) : v + 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Auto-submit cart quantity changes
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    const form = input.closest('form');
    if (form) form.submit();
  });

  /* ---------- Header: search + mobile nav ---------- */
  const search = $('[data-search]');
  const searchOpen = $('[data-search-open]');
  if (search && searchOpen) {
    searchOpen.addEventListener('click', (e) => {
      e.preventDefault();
      search.hidden = !search.hidden;
      if (!search.hidden) $('[data-search-input]', search).focus();
    });
    $('[data-search-close]', search).addEventListener('click', () => { search.hidden = true; });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') search.hidden = true; });
  }

  const mobileNav = $('[data-mobile-nav]');
  if (mobileNav) {
    const open = () => { mobileNav.classList.add('is-open'); mobileNav.setAttribute('aria-hidden', 'false'); document.body.classList.add('menu-open'); $('[data-menu-open]').setAttribute('aria-expanded', 'true'); };
    const close = () => { mobileNav.classList.remove('is-open'); mobileNav.setAttribute('aria-hidden', 'true'); document.body.classList.remove('menu-open'); $('[data-menu-open]').setAttribute('aria-expanded', 'false'); };
    $$('[data-menu-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-menu-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  const header = $('[data-header]');
  if (header && header.classList.contains('header--transparent')) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 80);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Sticky buy bar: visible after the hero, hidden while the buy box is on screen ---------- */
  const buybar = $('[data-buybar]');
  if (buybar && 'IntersectionObserver' in window) {
    const hero = $('[data-hero]');
    const buy = $('#buy');
    let heroOut = !hero, buyIn = false;
    const apply = () => {
      const show = heroOut && !buyIn;
      if (show) buybar.hidden = false;
      requestAnimationFrame(() => buybar.classList.toggle('is-visible', show));
      document.body.classList.toggle('has-buybar', show);
      if (!show) setTimeout(() => { if (!buybar.classList.contains('is-visible')) buybar.hidden = true; }, 320);
    };
    if (hero) new IntersectionObserver(([e]) => { heroOut = !e.isIntersecting && e.boundingClientRect.top < 0; apply(); }, { threshold: 0 }).observe(hero);
    if (buy) new IntersectionObserver(([e]) => { buyIn = e.isIntersecting; apply(); }, { threshold: 0.15 }).observe(buy);
  }

  /* ---------- Feature story: swap pinned image as chapters scroll ---------- */
  $$('[data-story]').forEach((story) => {
    const chapters = $$('[data-story-chapter]', story);
    const imgs = $$('[data-story-img]', story);
    if (!chapters.length || !('IntersectionObserver' in window)) return;
    const activate = (i) => {
      chapters.forEach((c) => c.classList.toggle('is-active', c.dataset.storyChapter === String(i)));
      imgs.forEach((im) => im.classList.toggle('is-active', im.dataset.storyImg === String(i)));
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) activate(en.target.dataset.storyChapter); });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    chapters.forEach((c) => io.observe(c));
  });

  /* ---------- Announcement rotation (mobile) ---------- */
  const ann = $('[data-announcement]');
  if (ann) {
    const items = $$('.announcement__item', ann);
    if (items.length > 1) {
      let i = 0;
      items[0].classList.add('is-current');
      setInterval(() => {
        items[i].classList.remove('is-current');
        i = (i + 1) % items.length;
        items[i].classList.add('is-current');
      }, 4000);
    } else if (items[0]) {
      items[0].classList.add('is-current');
    }
  }

  /* ---------- Collection sort ---------- */
  const sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Video: click-to-load embed ---------- */
  $$('[data-video]').forEach((frame) => {
    const btn = $('[data-video-play]', frame);
    const tpl = $('[data-video-embed]', frame);
    if (!btn || !tpl) return;
    btn.addEventListener('click', () => {
      frame.innerHTML = '';
      frame.appendChild(tpl.content.cloneNode(true));
    });
  });

  /* ---------- Product page ---------- */
  const product = $('[data-product]');
  if (product) {
    const picker = $('[data-variant-picker]', product);
    const gallery = $('[data-gallery]', product);
    const form = $('[data-product-form]', product);
    const idInput = $('[data-variant-id]', product);
    const addBtn = $('[data-add-to-cart]', product);
    const addText = $('[data-add-text]', product);
    const stickyBar = $('[data-sticky-atc]', product);
    const stickyAdd = $('[data-sticky-add]', product);
    const stickyPrice = $('[data-sticky-price]', product);

    // Gallery
    if (gallery) {
      const slides = $$('[data-gallery-slide]', gallery);
      const thumbs = $$('[data-gallery-thumb]', gallery);
      const show = (mediaId) => {
        slides.forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === String(mediaId)));
        thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.mediaId === String(mediaId)));
        // pause any playing video in inactive slides
        slides.forEach((s) => { if (!s.classList.contains('is-active')) $$('video', s).forEach((v) => v.pause()); });
      };
      thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.mediaId)));
      gallery.showMedia = show;
    }

    // Variants
    if (picker) {
      const variants = JSON.parse($('[data-variants]', picker).textContent);
      const radios = $$('input[type="radio"]', picker);
      const priceWrap = $('[data-price]', product);

      const selectedOptions = () => {
        const opts = [];
        radios.forEach((r) => { if (r.checked) opts[parseInt(r.dataset.optionIndex, 10)] = r.value; });
        return opts;
      };

      const updateAvailability = (opts) => {
        radios.forEach((r) => {
          const idx = parseInt(r.dataset.optionIndex, 10);
          const test = opts.slice();
          test[idx] = r.value;
          const match = variants.some((v) => v.available && v.options.every((o, i) => o === test[i]));
          r.nextElementSibling.classList.toggle('is-unavailable', !match);
        });
      };

      const apply = () => {
        const opts = selectedOptions();
        const variant = variants.find((v) => v.options.every((o, i) => o === opts[i]));
        // Update legend labels
        $$('fieldset', picker).forEach((fs, i) => { const s = $('[data-option-value]', fs); if (s && opts[i]) s.textContent = opts[i]; });
        updateAvailability(opts);
        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addText.textContent = 'Unavailable'; }
          if (stickyAdd) stickyAdd.disabled = true;
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceWrap) {
          $('[data-price-current]', priceWrap).textContent = formatMoney(variant.price);
          const cmp = $('[data-price-compare]', priceWrap);
          const save = $('[data-price-save]', priceWrap);
          const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          priceWrap.classList.toggle('price--sale', !!onSale);
          if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = formatMoney(variant.compare_at_price); }
          if (save) { save.hidden = !onSale; if (onSale) save.textContent = `Save ${Math.round((1 - variant.price / variant.compare_at_price) * 100)}%`; }
        }
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        if (addBtn) { addBtn.disabled = !variant.available; addText.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
        if (stickyAdd) stickyAdd.disabled = !variant.available;
        if (variant.featured_media && gallery && gallery.showMedia) gallery.showMedia(variant.featured_media.id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      };
      radios.forEach((r) => r.addEventListener('change', apply));
      updateAvailability(selectedOptions());
    }

    // Sticky add-to-cart (shows once the main button scrolls out of view)
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.hidden = !show;
        requestAnimationFrame(() => stickyBar.classList.toggle('is-visible', show));
        document.body.classList.toggle('has-sticky-atc', show);
      }, { threshold: 0 });
      io.observe(addBtn);
      if (stickyAdd) stickyAdd.addEventListener('click', () => addToCart(form, stickyAdd));
    }

    // Recommendations via Section Rendering API
    const recs = $('[data-recommendations]');
    if (recs && recs.dataset.url) {
      fetch(recs.dataset.url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = $('[data-recommendations]', doc);
          if (inner && inner.innerHTML.trim()) recs.innerHTML = inner.innerHTML;
        })
        .catch(() => {});
    }
  }

  /* ---------- Subtle reveal ---------- */
  function reveal(root) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;
    const targets = $$('.card, .review, .split__copy, .split__media, .story__head, .compare__table, .specs__head, .buy__panel, .showcase__frame', root).filter((t) => !t.hasAttribute('data-reveal'));
    targets.forEach((t, i) => { t.setAttribute('data-reveal', ''); t.style.transitionDelay = `${(i % 4) * 60}ms`; });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach((t) => io.observe(t));
  }
  reveal(document);

  /* ---------- Theme editor hooks ---------- */
  document.addEventListener('shopify:section:load', (e) => reveal(e.target));
})();
